/**
 * Reacao unica a "a sessao acabou".
 *
 * Responsabilidade: guardar UMA funcao, registrada pelo `main.ts`, que leva o
 * app de volta ao login. `ws.ts` (fechamento 1008) e `acoes.ts` (401 no REST)
 * chegam a essa conclusao por caminhos diferentes e precisam terminar no mesmo
 * lugar.
 *
 * NAO e responsabilidade deste arquivo: decidir QUE tela mostrar — quem sabe
 * disso e o `main.ts`, que registra o comportamento aqui.
 *
 * Existe para nao haver duas implementacoes de "deslogar": uma que limpa cache
 * e outra que so troca a tela divergiriam no primeiro caso de borda.
 */

let encerramento: () => void = () => {};

export function definirEncerramento(fn: () => void): void {
  encerramento = fn;
}

export function encerrar(): void {
  encerramento();
}
